<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-10">
          <chart-card :key='gitlab_costs_data' :chart-data="gitlab_costs_data.data"
                      :chart-options="gitlab_costs_data.options"
                      :responsive-options="gitlab_costs_data.responsiveOptions"
                      chart-type="Bar"
                      >
            <template slot="header">
              <h4 class="card-title">Gitlab Invoices</h4>
              <p class="card-category">Values in $</p>
            </template>
            <template slot="footer">
              <!-- <div class="legend">
                <i class="fa fa-circle" :style='{color: colors[0]}'></i> AWS Costs
                <i class="fa fa-circle" :style='{color: colors[1]}'></i> License (simulated)
                <i class="fa fa-circle" :style='{color: colors[2]}'></i> gitlab Support (simulated)
              </div> -->
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
              </div>
            </template>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import axios from 'axios'

  import { colors, formatMoney, formatSimple } from 'src/globalVariables'
  import { setInterval } from 'timers';

  Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
  }

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    async created() {
      this.accessToken = await this.$auth.getAccessToken()
      this.loadData()
      var vm = this
      setInterval(function(){
        vm.loadData()
      },vm.refresh_minutes*60*1000)

    },
    methods: {
      loadData: function(){
        var today = new Date();
        this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
        console.log('refreshing...',)
        axios
          .get('invoices/current-data?access_token=' + this.accessToken + '&vendor_name=GitLab&st_date=201801&fn_date=201912')
          .then(response => (this.gitlab_invoices = response.data))
        return true
      },
      refresh_gitlab: function() {
        var labels = []
        var series1 = []
        console.log(this.gitlab_invoices)
        if (this.gitlab_invoices){
          this.gitlab_invoices.forEach(function(v, i){
            labels.push(v['period'])
            series1.push(parseFloat(v['cost']))

          })
          this.gitlab_costs_data = {
            'data': {
              'labels': labels,
              'series': [series1]
            },
            'options': {
              'stackBars': true,
              'seriesBarWidth': 50,
              'seriesBarDistance': 50,
              'axisX': {
                'showGrid': true
              },
              'height': '245px',
              'chartPadding': {
                'right': 50,
                'left': 50,
              },
              'tooltip':{
                'tooltipFnc': function(meta, value){
                  return(value)
                },

                tooltipOffset: {
                  x: 15,
                  y: 90
                },
                'appendToBody':false,
                'transformTooltipTextFnc': function(value) {
                  return ''+ formatMoney.format(value)
                  }
              },
              // 'ctPointLabels':{
              //   'textAnchor': 'middle',
              //   'labelOffset': {
              //     'x': 0,
              //     'y': -10
              //   },
              //   // labelInterpolationFnc: function(value) {return '$' + value.toFixed(2)}
              // }
            },
            'responsiveOptions': [
              ['screen and (max-width: 640px)', {
                'seriesBarDistance': 20,
                'axisX': {
                  labelInterpolationFnc (value) {
                    return value[0]
                  }
                }
              }]
            ]
          }

        }

      }
    },
    watch: {
      gitlab_invoices:function(){
        this.refresh_gitlab()
      },
    },
    computed: {

    },
    data () {
      return {
        refresh_minutes: 30,
        last_update: '',
        colors: colors,
        gitlab_invoices:{},
        gitlab_costs_data:{},
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        accessToken: '',
      }
    }
  }
</script>
<style>

</style>
